import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { KaliopMenuTransformer } from 'src/models/Menu/Menu'

import { HeaderProps } from '../components/Header'
import { selectors } from '../redux'

import { useSsoUrl } from './useSsoUrl'

const useApplication = () => {
  const menu = useSelector(selectors.app.menu)
  const { t } = useTranslation()
  const ssoLoginUrl = useSsoUrl('fam_find')

  const userLoggedIn = !!useSelector(selectors.user.keycloakToken)
  const headerProps = {
    textClose: t('header_close'),
    textBack: t('header_back'),
    linkAccount: {
      text: t('my_account'),
      href: userLoggedIn
        ? `${process.env.MANGER_BOUGER_ROOT}/mon-compte`
        : ssoLoginUrl,
    },
    linkHome: {
      text: t('header_home'),
      href: '/',
    },
    logos: [
      {
        linkProps: null,
        imageProps: {
          src: '/images/header/logo-republique-francaise.svg',
          alt: 'République française',
          width: 50,
          height: 50,
          layout: 'intrinsic',
        },
      },
      {
        linkProps: {
          href: 'https://www.santepubliquefrance.fr/',
          target: '_blank',
          title: 'Site de la Santé Publique Française',
          rel: 'noreferrer',
        },
        imageProps: {
          src: '/images/header/logo-sante-publique.svg',
          alt: 'Santé Publique Française',
          width: 100,
          height: 50,
          layout: 'intrinsic',
        },
      },
    ],
    logoMain: {
      linkProps: {
        href: process.env.MANGER_BOUGER_ROOT || '/',
        title: "Retour à la page d'accueil",
      },
      imageProps: {
        src: '/images/header/logo-manger-bouger.svg',
        alt: 'Manger Bouger',
        width: 224,
        height: 36,
        layout: 'responsive',
      },
    },
    socials: [
      {
        actionProps: {
          href: t('socials_facebook_url'),
        },
        text: 'Facebook',
        icon: 'socialFacebook',
        variantType: 'link',
        variantColorScheme: 'iconGreenApple',
        variantIcon: 'only',
      },
      {
        actionProps: {
          href: t('socials_instagram_url'),
        },
        text: 'Instagram',
        icon: 'socialInstagram',
        variantType: 'link',
        variantColorScheme: 'iconGreenApple',
        variantIcon: 'only',
      },
    ],
    navMenuProps: menu && KaliopMenuTransformer(menu),
    search: {
      placeholder: t('header_search_placeholder'),
      onSearch: (search) =>
        (window.location.href = `${process.env.MANGER_BOUGER_ROOT}/recherche?searchName=${search}`),
      searchText: t('header_search'),
    },
    mobileSearchText: t('header_search_mobile_heading'),
  } as HeaderProps

  return { headerProps }
}

export default useApplication
